export default {
    IWLCA: {
        Pricing: require('./components/Domains/IWLCA/Pricing/Pricing').default,
        ActivityPromoCard: require('./components/Domains/IWLCA/ActivityFeed/PromoCard').default,
        FreeAthleteModal: require('./components/Domains/IWLCA/FreeAthleteModal').default,
        MessageComposeWarning: require('./components/Domains/IWLCA/MessageComposeWarning').default,
    },
    IMLCA: {
        Pricing: require('./components/Domains/IMLCA/Pricing/Pricing').default,
        ActivityPromoCard: require('./components/Domains/IWLCA/ActivityFeed/PromoCard').default,
        FreeAthleteModal: require('./components/Domains/IWLCA/FreeAthleteModal').default,
        MessageComposeWarning: require('./components/Domains/IWLCA/MessageComposeWarning').default,
    },
    NFHCA: {
        FreeAthleteModal: require('./components/Domains/IWLCA/FreeAthleteModal').default,
        MessageComposeWarning: require('./components/Domains/IWLCA/MessageComposeWarning').default,
    },
}